<form>
    <!--
    <mat-form-field appearance="outline">
        <mat-label>Created On (UTC)</mat-label>
        <input matInput *ngIf="envelope" name="CreatedOn" disabled="disabled" [(ngModel)]="envelope.CreatedOnUTC" />
    </mat-form-field>
    <br />
    <mat-form-field appearance="outline">
        <mat-label>Created By</mat-label>
        <input matInput *ngIf="envelope" name="CreatedBy" disabled="disabled" [(ngModel)]="envelope.CreateUserUID" />
    </mat-form-field>
    <br />
    <mat-form-field *ngIf="envelope.ModifiedOnUTC" appearance="outline">
        <mat-label>Modified On (UTC)</mat-label>
        <input matInput *ngIf="envelope" name="ModifiedOn" disabled="disabled" [(ngModel)]="envelope.ModifiedOnUTC" />
    </mat-form-field>
    <br />
    <mat-form-field *ngIf="envelope.ModifyUserUID" appearance="outline">
        <mat-label>Modified By</mat-label>
        <input matInput *ngIf="envelope" name="ModifiedBy" disabled="disabled" [(ngModel)]="envelope.ModifyUserUID" />
    </mat-form-field>
    -->
    <mat-card *ngIf="itemEnvelope">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    history
                </mat-icon>
                <span>
                    Edit history
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Created on {{ itemEnvelope.CreatedOnUTC }} UTC by user {{ itemEnvelope.CreateUserUID }}
                <br />
                Last edited on {{ itemEnvelope.ModifiedOnUTC }} UTC by user {{ itemEnvelope.ModifyUserUID }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <!--<div>
                Created on {{ itemEnvelope.CreatedOnUTC }} UTC by user {{ itemEnvelope.CreateUserUID }}
            </div>
            <br />
            <div *ngIf="envelope.ModifiedOnUTC">
                Last edited on {{ itemEnvelope.ModifiedOnUTC }} UTC by user {{ itemEnvelope.ModifyUserUID }}
            </div>-->
            <!--<button mat-button>
                <mat-icon class="material-symbols-outlined">
                    history
                </mat-icon>
                VIEW HISTORY DETAIL
            </button>-->
        </mat-card-content>
    </mat-card>
    <br />
    <div class="history-container-section">
        <mat-chip-list class="mat-chip-list-stacked" aria-orientation="vertical">
            <mat-chip *ngFor="let revision of revisions" (click)="showRevision(revision)" class="revision-chip">
                <mat-icon>history</mat-icon>
                {{ revision.RevisionOrdinal }} on {{ revision.RevisedOnUTC }} by {{ revision.RevisionUserUID }}
            </mat-chip>
        </mat-chip-list>
    </div>
</form>
